import React from 'react';
import { EuiIconTip } from 'stable-eui';

export default function (props) {
  return (
    <EuiIconTip
      aria-label="Postal"
      size="xxl"
      type="logoMaps"
      color="rgba(0, 125, 116, .8)"
      content={props.text}
    />
  );
}
